export default "__VITE_ASSET__BHn4cs3X__"